module.exports = __webpack_public_path__ + "img/ylkt4-2.a4c73381.jpg";